import { z } from 'zod'
import { amDateShema } from 'src/common-services/types/alphamap/generic-types'
import { boundaryType, visitorOriginType } from 'src/common-services/types/alphamap/mobility-types'

export const amDemographicsLocationByVisitorsHomeRequestSchema = z.object({
  id: z.string(),
  startDate: amDateShema,
  endDate: amDateShema,
  visitorOrigin: visitorOriginType.default('home').optional(),
  type: boundaryType.default('zipcode').optional(),
  percentageFilter: z.number().min(0).max(1).default(1).optional(),
})

export type AMDemographicsLocationByVisitorsHomeRequest = z.infer<
  typeof amDemographicsLocationByVisitorsHomeRequestSchema
>

export const amDemographicsAttributeScoreShema = z.object({
  measure: z.string(),
  medianOfMAADS: z.number(),
  medMAADofMedians: z.number(),
})

export type AMDemographicsAttributeScore = z.infer<typeof amDemographicsAttributeScoreShema>

export const brandHouseholdIncomeHistogramRequestSchema = z.object({
  id: z.string().uuid(),
  miles: z.number().refine((val) => [1, 3, 5].includes(val), {
    message: 'Miles must be 1, 3, or 5',
  }),
})
export type BrandHouseholdIncomeHistogramRequest = z.infer<typeof brandHouseholdIncomeHistogramRequestSchema>

export const brandDemographcisHistogramDataSchema = z.object({
  buckets: z.array(
    z.object({
      bucket: z.number(),
      count: z.number(),
    })
  ),
  totalLocations: z.number(),
  min: z.number(),
  max: z.number(),
  median: z.number(),
  medianBucket: z.number(),
  top10: z.object({
    totalLocations: z.number(),
    avg: z.number(),
    bucket: z.number(),
  }),
  bottom10: z.object({
    totalLocations: z.number(),
    avg: z.number(),
    bucket: z.number(),
  }),
})
export type BrandDemographicsHistogramData = z.infer<typeof brandDemographcisHistogramDataSchema>
